/** Shuffle, repeat and volume — the controls that survive a wide layout. */

import { type Component, Show } from 'solid-js';
import { cycleRepeat, toggleShuffle } from '../../app/commands.ts';
import { repeat, shuffle } from '../../state/player.ts';
import { Repeat, Shuffle } from '../icons/media.tsx';
import styles from './Transport.module.css';
import { Volume } from './Volume.tsx';

export const Extras: Component = () => (
  <div class={styles.extras}>
    <button
      type="button"
      class={[styles.xbtn, { [styles.on as string]: shuffle() }]}
      title="Shuffle (X)"
      aria-label="Shuffle"
      aria-pressed={shuffle() ? 'true' : 'false'}
      onClick={toggleShuffle}
    >
      <Shuffle />
    </button>

    <button
      type="button"
      class={[styles.xbtn, { [styles.on as string]: repeat() !== 'off' }]}
      title="Repeat (R)"
      aria-label="Repeat"
      onClick={cycleRepeat}
    >
      <Repeat />
      <Show when={repeat() === 'one'}>
        <span class={styles.badge}>1</span>
      </Show>
    </button>

    <Volume />
  </div>
);
